import { jsx as _jsx } from "react/jsx-runtime";
const PRECONNECT_DOMAINS = [
    "https://dapulse-res.cloudinary.com"
];
// we add all preconnect domains to dns-prefetch as a fallback.
const DNS_PREFETCH_DOMAINS = [
    ...PRECONNECT_DOMAINS
];
const PreconnectLinksComponent = ()=>{
    return [
        PRECONNECT_DOMAINS.map((link)=>/*#__PURE__*/ _jsx("link", {
                rel: "preconnect",
                href: link
            })),
        DNS_PREFETCH_DOMAINS.map((link)=>/*#__PURE__*/ _jsx("link", {
                rel: "dns-prefetch",
                href: link
            }))
    ];
};
export default PreconnectLinksComponent;
